export function failureCode(integrationFailure) {
  return integrationFailure.customFailure.code;
}
export function customFailure(integrationFailure) {
  return integrationFailure.customFailure;
}